import { SearchUserEnriched } from 'lib-search-types';

/**
 * Check whether an agent is currently in a phone or callback conversation. The
 * Search API's `workloads_by_channel` excludes conversations in ACW, so the
 * counts here represent live workload only.
 */
export function isAgentOnThePhone(member: SearchUserEnriched): boolean {
  const phone = member.workloads_by_channel?.pstn_phone ?? 0;
  const callback = member.workloads_by_channel?.callback ?? 0;
  return phone + callback > 0;
}
